import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'parentheses'})
export class ParenthesesPipe implements PipeTransform {
  transform(value: string, apply = true): string {
    if(apply) {
          return `(${value})`;
    }
    return value;
  }
}
